import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const apiUrlUsers = `${process.env.REACT_APP_API_URL}/users`;
const apiUrlSectores = `${process.env.REACT_APP_API_URL}/section`;
const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;
const apiUrlEmpresas = `${process.env.REACT_APP_API_URL}/empresas`;

const EditUser = () => {
    const { id } = useParams();
    const [usuario, setUsuario] = useState('');
    const [pass, setPass] = useState('');
    const [nombreuser, setNombreUser] = useState('');
    const [apellido, setApellido] = useState('');
    const [tipo, setTipo] = useState('');
    const [sector, setSector] = useState('');
    const [ubicacion, setUbicacion] = useState('');
    const [sede, setSede] = useState('');
    const [sedes, setSedes] = useState([]);
    const [todasLasSedes, setTodasLasSedes] = useState([]);
    const [empresa, setEmpresa] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const apiUrlWithId = `${apiUrlUsers}/${id}`;
    const displayName = [nombreuser, apellido].filter(Boolean).join(' ') || usuario || 'este usuario';

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(apiUrlWithId);
                const userData = response.data;

                setUsuario(userData.usuario || '');
                setPass('');
                setNombreUser(userData.nombreuser || '');
                setApellido(userData.apellido || '');
                setTipo(userData.tipo || '');
                setSector(userData.sector || '');
                setSede(userData.id_sede ? String(userData.id_sede) : '');
            } catch (error) {
                console.error('Error fetching user:', error);
            } finally {
                setLoading(false);
            }
        };

        const fetchSectores = async () => {
            try {
                const response = await axios.get(apiUrlSectores);
                setSectores(response.data);
            } catch (error) {
                console.error('Error fetching sectors:', error);
            }
        };

        const fetchSedes = async () => {
            try {
                const response = await axios.get(apiUrlAddresses);
                const mapeadas = response.data.map(s => ({
                    id: String(s.id_direccion),
                    label: s.nombre_sede || `${s.direccion} - ${s.localidad}`,
                    direccion: s.direccion,
                    id_empresa: s.id_empresa
                }));
                setTodasLasSedes(mapeadas);
            } catch (error) {
                console.error('Error fetching sedes:', error);
            }
        };

        const fetchEmpresas = async () => {
            try {
                const response = await axios.get(apiUrlEmpresas);
                setEmpresas(response.data);
            } catch (error) {
                console.error('Error fetching empresas:', error);
            }
        };

        fetchUser();
        fetchSectores();
        fetchSedes();
        fetchEmpresas();
    }, [apiUrlWithId]);

    useEffect(() => {
        if (sede && todasLasSedes.length > 0) {
            const sedeObj = todasLasSedes.find(s => String(s.id) === String(sede));
            if (sedeObj && sedeObj.id_empresa) {
                setEmpresa(String(sedeObj.id_empresa));
            }
        }
    }, [sede, todasLasSedes]);

    useEffect(() => {
        if (empresa && todasLasSedes.length > 0) {
            const sedesFiltradas = todasLasSedes.filter(s => String(s.id_empresa) === String(empresa));
            setSedes(sedesFiltradas);
        } else {
            setSedes([]);
        }
    }, [empresa, todasLasSedes]);

    useEffect(() => {
        const sectorObj = sectores.find(sec => sec.sector === sector);
        if (sectorObj && sectorObj.id_sede) {
            setSede(String(sectorObj.id_sede));
        }
    }, [sector, sectores]);

    useEffect(() => {
        if (!sede) {
            setUbicacion('');
            return;
        }
        const s = sedes.find(x => String(x.id) === String(sede));
        if (s) {
            setUbicacion(s.direccion || '');
        }
    }, [sede, sedes]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!usuario.trim() || !nombreuser.trim() || !apellido.trim()) {
            alert('Complete usuario, nombre y apellido antes de guardar');
            return;
        }

        setIsSubmitting(true);
        try {
            const updatedUserData = {
                usuario: usuario.trim(),
                ...(pass && pass.trim() !== '' ? { pass: pass.trim() } : {}),
                nombreuser: nombreuser.trim(),
                apellido: apellido.trim(),
                tipo,
                sector,
                ubicacion,
                id_sede: Number(sede),
            };
            await axios.put(apiUrlWithId, updatedUserData);
            alert('Usuario actualizado exitosamente');
            navigate('/admin/AbmUsuarios');
        } catch (error) {
            console.error('Error al actualizar el usuario:', error);
            alert('Error al actualizar el usuario: ' + (error.response?.data?.message || error.message));
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleBack = () => {
        navigate('/admin/AbmUsuarios');
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-rose-100 flex items-center justify-center">
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                    <div className="flex items-center gap-4">
                        <svg className="animate-spin h-8 w-8 text-purple-600" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        <span className="text-lg font-semibold text-gray-700">Cargando datos del usuario...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-rose-100 py-8 px-4">
            <div className="max-w-5xl mx-auto">
                <div className="bg-white rounded-t-2xl shadow-xl p-6 border-b-4 border-pink-500">
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-purple-600 to-pink-600 p-4 rounded-xl shadow-lg">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4a4 4 0 100 8 4 4 0 000-8zm-7 16a7 7 0 0114 0" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Editar Usuario</h1>
                            <p className="text-gray-600 mt-1">
                                Modifica los datos de <span className="font-semibold text-pink-600">{displayName}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleUpdate} className="bg-white rounded-b-2xl shadow-xl p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="usuario" className="block text-sm font-semibold text-gray-700 mb-2">
                                Usuario
                            </label>
                            <input
                                id="usuario"
                                placeholder="Usuario de acceso"
                                type="text"
                                value={usuario}
                                onChange={(e) => setUsuario(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        <div>
                            <label htmlFor="pass" className="block text-sm font-semibold text-gray-700 mb-2">
                                Contraseña
                            </label>
                            <input
                                id="pass"
                                placeholder="Dejar vacio para no cambiarla"
                                type="password"
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-pink-500 focus:ring-2 focus:ring-pink-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        <div>
                            <label htmlFor="nombreuser" className="block text-sm font-semibold text-gray-700 mb-2">
                                Nombre
                            </label>
                            <input
                                id="nombreuser"
                                placeholder="Nombre"
                                type="text"
                                value={nombreuser}
                                onChange={(e) => setNombreUser(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-fuchsia-500 focus:ring-2 focus:ring-fuchsia-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        <div>
                            <label htmlFor="apellido" className="block text-sm font-semibold text-gray-700 mb-2">
                                Apellido
                            </label>
                            <input
                                id="apellido"
                                placeholder="Apellido"
                                type="text"
                                value={apellido}
                                onChange={(e) => setApellido(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-rose-500 focus:ring-2 focus:ring-rose-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        <div>
                            <label htmlFor="tipo" className="block text-sm font-semibold text-gray-700 mb-2">
                                Tipo de usuario
                            </label>
                            <select
                                id="tipo"
                                value={tipo}
                                onChange={(e) => setTipo(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all outline-none text-gray-800"
                            >
                                <option value="">Seleccione...</option>
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                                <option value="invitado">Invitado</option>
                                <option value="direccion">Direccion</option>
                            </select>
                        </div>

                        <div>
                            <label htmlFor="empresa" className="block text-sm font-semibold text-gray-700 mb-2">
                                Empresa
                            </label>
                            <select
                                id="empresa"
                                value={empresa}
                                onChange={(e) => {
                                    setEmpresa(e.target.value);
                                    setSede('');
                                    setSector('');
                                }}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all outline-none text-gray-800"
                            >
                                <option value="">Seleccione una empresa</option>
                                {empresas.map(emp => (
                                    <option key={emp.id_empresa} value={emp.id_empresa}>
                                        {emp.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label htmlFor="sede" className="block text-sm font-semibold text-gray-700 mb-2">
                                Sede
                            </label>
                            <select
                                id="sede"
                                value={sede}
                                onChange={(e) => setSede(e.target.value)}
                                disabled={!empresa}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200 transition-all outline-none text-gray-800 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {!empresa ? 'Primero seleccione una empresa' : 'Seleccione una sede'}
                                </option>
                                {sedes.map(s => (
                                    <option key={s.id} value={s.id}>{s.label}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label htmlFor="sector" className="block text-sm font-semibold text-gray-700 mb-2">
                                Sector
                            </label>
                            <select
                                id="sector"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                                disabled={!sede}
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 transition-all outline-none text-gray-800 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {!sede ? 'Primero seleccione una sede' : 'Seleccione un sector'}
                                </option>
                                {sectores
                                    .filter(sec => !sede || !sec.id_sede || String(sec.id_sede) === String(sede))
                                    .map((sectorObj) => (
                                        <option key={sectorObj.id_sector} value={sectorObj.sector}>
                                            {sectorObj.sector}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="md:col-span-2">
                            <label htmlFor="ubicacion" className="block text-sm font-semibold text-gray-700 mb-2">
                                Ubicacion
                            </label>
                            <input
                                id="ubicacion"
                                placeholder="Direccion derivada de la sede"
                                type="text"
                                value={ubicacion}
                                readOnly
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 bg-gray-50 text-gray-700 outline-none"
                            />
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t-2 border-gray-200">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-purple-700 hover:to-pink-700 transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        >
                            {isSubmitting ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    Actualizando...
                                </span>
                            ) : (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Guardar Cambios
                                </span>
                            )}
                        </button>

                        <button
                            type="button"
                            onClick={handleBack}
                            disabled={isSubmitting}
                            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg shadow-md transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancelar
                            </span>
                        </button>
                    </div>
                </form>

                <div className="mt-6 bg-pink-50 border-l-4 border-pink-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-pink-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-4a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 000 2v2a1 1 0 001 1h1a1 1 0 100-2v-2a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-pink-900">Ten en cuenta</p>
                            <p className="text-sm text-pink-700 mt-1">
                                Si deja la contrasena vacia, el sistema conserva la actual. La ubicacion se deriva automaticamente de la sede seleccionada.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditUser;
